<template>
  <div>
    <!-- 基础信息 -->
    <el-dialog :title="$t('message.basicInformation')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="content">
        <el-form :model="detail" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <!-- 系统登录名 -->
          <el-form-item :label="$t('message.systemLoginName')" prop="username">
            <el-input v-model="detail.username"></el-input>
          </el-form-item>
          <!-- 全名（真名 -->
          <el-form-item :label="$t('message.fullName')">
            <el-input v-model="detail.realname"></el-input>
          </el-form-item>
          <!-- 邮箱 -->
          <el-form-item :label="$t('message.email')" prop="email">
            <el-input v-model="detail.email"></el-input>
          </el-form-item>
          <!-- 手机号： -->
          <el-form-item :label="$t('message.mobile')" prop="mobile">
            <el-input v-model="detail.mobile"></el-input>
          </el-form-item>
          <!-- 电话号码 -->
          <el-form-item :label="$t('message.telephoneNumber')">
            <el-input v-model="detail.tel"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
      days: "",
      rules: {
        username: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
          { min: 2, max: 24, message: "长度在 2 到 24 个字符", trigger: 'blur' },
          {
            pattern: /^(?!^\d+$)/,
            message: "不能输入纯数字",
            trigger: "blur",
          },

        ],
        realname: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "メールアドレスを入力してください",
            trigger: "blur",
          },
          {
            type: "email",
            message: "正しいメールアドレスをご記入ください",
            trigger: ["blur", "change"],
          },
        ],
        mobile: [
          {
            required: true,
            message: "日本国内の携帯番号",
            trigger: "blur",
          },
          {
            min: 11, max: 11,
            message: "日本国内の携帯番号长度为11位",
            trigger: "blur",
          },
          // {
          //   pattern: /^(81)?\-?0?[56789](?:\d{8}|\d{9})$/,
          //   message: "日本国内の携帯番号",
          //   trigger: "blur",
          // },
        ],
        tel: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 保存
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.detail.user_id = this.detail.id;

          this.$api.clienteleApi.updateUserKeyInfo(this.detail).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.clientDetail();
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 8px;

  p {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 24px;
  }

  .row {
    margin-bottom: 24px;
  }

  /deep/.el-radio__input {
    transform: scale(1.5) !important;
  }
}
</style>